<template>
    <div class="tree-box">
        <div v-for="(item,index) in treeData" :key="index" class="tree-item">
            <div class="item">
                <i class="iconfont icon-jian" @click="delItem(item,index)"></i>
                <div>章节名称</div>
                <el-input v-model="item.name" style="width: 25rem;margin-left: 1rem;" placeholder="请输入内容"></el-input>
                <div @click="addFlatLevel">添加平级</div>
                <div @click="addChild(item)">添加子级</div>
            </div>
            <catalog-tree style="margin-left: 5rem;" :parentId="item.id" v-if="item.children&&item.children.length>0" :treeData="item.children"></catalog-tree>
        </div>
    </div>
</template>

<script>
import { generateSixDigitUUID } from '@/utils/utils';
    export default {
        name:'CatalogTree',
        props:{
            treeData:{
                require:true,
                default:()=>[]
            },
            parentId:{
                require:true,
                default:''
            },
        },
        computed:{
            courseId(){
                return this.$store.state.course.currentCourseId||this.$route.query.id||'';
            }
        },
        methods:{
            /**添加平级 */
            addFlatLevel(){
                this.treeData.push({
                        "courseId": this.courseId,
                        "icon": "",
                        "id":generateSixDigitUUID(),
                        "name": '',
                        "orderIndex": this.treeData.length+1,
                        "parentId": this.parentId
                });
            },
            /**删除节点 */
            delItem(item,index){
                if(item.parentId==-1&&this.treeData.length==1){
                    this.$msg({
                                showClose: true,
                                message: "至少保留一个章节",
                                type: "warning",
                            });
                    return;
                }
                this.treeData.splice(index,1);
            },
            /**添加子级 */
            addChild(item){
                if(typeof item.children=='object'){
                    item.children.push({
                        "courseId": this.courseId,
                        "icon": "",
                        "id":generateSixDigitUUID(),
                        "name": "",
                        "orderIndex": item.children?item.children.length+1:1,
                        "parentId": item.id
                    })
                }else{
                    this.$set(item,'children',[{
                        "courseId": this.courseId,
                        "icon": "",
                        "id":generateSixDigitUUID(),
                        "name": "",
                        "orderIndex": item.children?item.children.length+1:1,
                        "parentId": item.id
                    }])
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.tree-item{
    margin-top: 2.4rem;
}
.item{
    display: flex;
    align-items: center;
    color: #334681;
    &> :nth-child(2){
        margin-left: 1rem;
        font-size: 16px;
    }
    &> :nth-child(4){
        margin-left: 1.5rem;
        color: var(--blue);
        cursor: pointer;
    }
    &> :nth-child(5){
        margin-left: 1.5rem;
        color: var(--blue);
        cursor: pointer;
    }
}
.icon-jian{
    color: var(--blue);
    cursor: pointer;
    font-size: 2rem;
}
</style>